/**
 * @generated SignedSource<<8736bd914fcff7324773ee5c41dc5c2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NewSignboardType = "newSignboard" | "noHave" | "takingOver";
export type businessSignboardQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessSignboardQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly isNewSignboard: NewSignboardType | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly ofbDt: string | null | undefined;
    }> | null | undefined;
  };
};
export type businessSignboardQuery = {
  response: businessSignboardQuery$data;
  variables: businessSignboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "bmanTin",
    "variableName": "bmanTin"
  },
  {
    "kind": "Variable",
    "name": "refundHistoryId",
    "variableName": "refundHistoryId"
  }
],
v3 = [
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ofbDt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isNewSignboard",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessSignboardQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessSignboardQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1b79199d328f03ed1d2e3d95859cf6dc",
    "id": null,
    "metadata": {},
    "name": "businessSignboardQuery",
    "operationKind": "query",
    "text": "query businessSignboardQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    business {\n      ofbDt\n    }\n  }\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      isNewSignboard\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca68a3918af3fc65637fc42458c22e53";

export default node;
